/**
 * RL-1666 (decision D7, review): a waiting-room TV signs in with its own
 * display account (API role `waiting_room_display`, one per branch, created
 * by the Super admin). Such an account holds exactly `waiting_room:read`.
 * Only then is the idle lock skipped; every other role keeps it, even on the
 * waiting-room page.
 */
export const DISPLAY_PERMISSION = 'waiting_room:read';

export function isDisplayAccount(
  permissions: readonly string[] | undefined | null,
): boolean {
  return (
    !!permissions &&
    permissions.length === 1 &&
    permissions[0] === DISPLAY_PERMISSION
  );
}
